'use strict';
const angular = require('angular');

/*@ngInject*/
export function dayOfWeekFilter() {
  return function(input) {
    let dayKey = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return dayKey[input];
  };
}


export default angular.module('fiapiApp.dayOfWeek', [])
  .filter('dayOfWeek', dayOfWeekFilter)
  .name;



// WEBPACK FOOTER //
// ./client/filters/dayOfWeek/dayOfWeek.filter.js